import { Outlet, type RouteObject } from 'react-router';
import { ConsultantDeadlinesAssistantShell } from '../../components/assistant/consultant-deadlines-assistant-shell';
import { SurveyAuthoringAssistantShell } from '../../components/assistant/survey-authoring-assistant';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { ConsultantGuard } from '../guards/consultant.guard';
import { PartnerGuard } from '../guards/partner.guard';
import { SurveyBuilderDesktopOnlyGuard } from '../guards/survey-builder-desktop-only.guard';
import { lazyRoute } from '../lazy-route';

export const consultantRoutes: RouteObject[] = [
  {
    path: '/consultant',
    element: <ConsultantGuard />,
    children: [
      {
        path: RoutesList.CONSULTANT_CLIENTS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRoute(() => import('../../pages/consultant/consultant-clients-page')),
          },
        ],
      },
      {
        path: RoutesList.CONSULTANT_CLIENT_STATS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRoute(() => import('../../pages/consultant/client-stats/client-stats-page')),
          },
          {
            path: ':tenantId',
            ...lazyRoute(
              () => import('../../pages/consultant/client-stats/client-stats-detail-page'),
            ),
          },
          {
            // Modale "non conformità" del dettaglio cliente: stessa pagina con
            // la dialog routata sopra (convenzione useRouteDialog).
            path: ':tenantId/nc/:cardId',
            ...lazyRoute(
              () => import('../../pages/consultant/client-stats/client-stats-detail-page'),
            ),
          },
        ],
      },
      {
        path: RoutesList.CONSULTANT_DEADLINES,
        element: <ConsultantDeadlinesAssistantShell />,
        children: [
          {
            index: true,
            ...lazyRoute(
              () => import('../../pages/consultant/deadlines/consultant-deadlines-page'),
            ),
          },
        ],
      },
      {
        path: RoutesList.CONSULTANT_REQUESTS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRoute(() => import('../../pages/consultant/requests/consultant-requests-page')),
          },
          {
            path: ':inviteId',
            ...lazyRoute(
              () => import('../../pages/consultant/requests/consultant-request-detail-page'),
            ),
          },
        ],
      },
      {
        path: RoutesList.CONSULTANT_STUDIO_TEMPLATES,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRoute(
              () => import('../../pages/consultant/studio-templates/studio-templates-page'),
            ),
          },
          {
            // Editor del template (F6): pagina dedicata, non modale; il dettaglio
            // porta id nel path e resta lazy come il resto del modulo.
            path: ':id',
            ...lazyRoute(
              () => import('../../pages/consultant/studio-templates/studio-template-editor-page'),
            ),
          },
        ],
      },
      {
        path: RoutesList.CONSULTANT_SURVEYS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRoute(() => import('../../pages/consultant/surveys/survey-studio-list-page')),
          },
        ],
      },
      {
        // Desktop-only come il builder admin (il messaggio riusa le chiavi
        // admin.*, accettabile v1 — spec D9). L'index è wrappato nella shell
        // dell'assistente di authoring (Task 14): FAB+panel esistono SOLO su
        // questa rotta, con overlay schema e pageUrl del builder. La shell è
        // un layout-route (<Outlet /> come children): la pagina lazy del
        // builder monta dentro il suo overlay-ref context.
        path: RoutesList.CONSULTANT_SURVEY_BUILDER,
        element: <SurveyBuilderDesktopOnlyGuard />,
        children: [
          {
            element: (
              <SurveyAuthoringAssistantShell>
                <Outlet />
              </SurveyAuthoringAssistantShell>
            ),
            children: [
              {
                index: true,
                // Export default (SurveyStudioBuilderPageRoute): legge l'overlay
                // ref dal context della shell, come la variante routed pre-refactor.
                ...lazyRoute(
                  () => import('../../pages/consultant/surveys/survey-studio-builder-page'),
                ),
              },
            ],
          },
        ],
      },
      {
        path: RoutesList.CONSULTANT_PARTNER,
        element: <PartnerGuard />,
        children: [
          {
            element: <MainLayout />,
            children: [
              {
                index: true,
                ...lazyRoute(() => import('../../pages/consultant/consultant-partner-page')),
              },
            ],
          },
        ],
      },
    ],
  },
];
